<template v-if="blogItems && blogItems.length > 0">
  <div class="row news bg-dark rounded px-3 pt-3 pb-1 my-3">
    <h4 class="w-100 pl-2">{{ blogHeading }}</h4>
    <div
      v-for="(blogItem, i) in blogItems.slice(0, 3)"
      :key="i"
      class="col-md-4"
    >
      <a v-bind:href="blogItem.url">
        <div class="card mb-4 shadow-sm">
          <img v-if="blogItem.media" v-bind:src="blogItem.media.thumbnail.url" />
          <div class="card-body">
            <h6 class="card-text">{{ blogItem.title }}</h6>
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted">{{
                blogItem.publishDate | formatDate
              }}</small>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      blogHeading: (state) => state.company.blogHeading,
      blogUrl: (state) => state.company.blogUrl,
      blogItems: (state) => state.feed.items,
    }),
  },
  watch: {
    blogUrl: function(newValue, oldValue) {
      if (newValue !== null) {
        this.$store.dispatch("feed/fetchFeed", newValue);
      } else {
        this.$store.state.feed.items = [];
      }
    },
  },
  methods: {},
  created() {
    this.$store.dispatch("company/fetchCompany").then(() => {
      if (this.blogUrl) {
        this.$store.dispatch("feed/fetchFeed", this.blogUrl);
      }
    });
  },
};
</script>

<style lang="scss">
.news img {
  width: 100%;
  height: 100%;
}
</style>
